import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";

export type PostTransactionPayload = {
  value: number;
  customerId: string;
  Prazo: number;
  type: PartnerType;
  clientId: string;
  simulationId?: string;
  refinancingId?: string;
  refinRecurring?: boolean;

  offerId?: string;
  ddd?: number;
  phone?: number;
};

export type PostTransactionResponse = {
  _id: string;
  contract: string;
  value: number;
  status: string;
  seller: unknown;
  customer: unknown;
  createdAt: string;
  updatedAt: string;
};

export async function postTransaction(payload: PostTransactionPayload) {
  const response = await httpClient
    .post<PostTransactionResponse>(`/crefisa/transaction`, payload)
    .catch((error) => {
      throw error.response?.data || error;
    });

  return response.data;
}
